// Module
var code = "<a href ng-click=\"$ctrl.openLinkInformation()\"><i class=\"fa fa-info-circle text-info\"></i></a> ";
// Exports
export default code;